import React from "react";

import toast from "components/ui/toast/Toast";
import TooltipComponent from "components/ui/tooltip/Tooltip";
import { useHideNotice } from "lib/hooks/api/notices/useHideNotice";
import Button from "../ui/button/Button";

type Props = {
  procurementStage: {
    id: string;
    stage: string;
  };
  score: number | null | undefined;
  signalTypes: Record<string, string[]> | undefined;
  contextSource: string;
  noticeId: string;
  noticeName: string;
  size?: "small" | "default";
  onClick?: () => void;
};

export function HideNoticeButton({
  size = "default",
  procurementStage,
  noticeId,
  noticeName,
  signalTypes,
  score,
  contextSource,
  onClick,
}: Props) {
  const { hideNotice } = useHideNotice(
    { guid: noticeId, procurementStage, score, signalTypes },
    contextSource,
    {
      onSuccess: () => {
        onClick?.();

        toast.message(`${noticeName} hidden for your team`);
      },
      onError: () => {
        toast.error("Failed to hide notice");
      },
    },
  );

  return (
    <TooltipComponent content={size === "small" ? "Hide notice" : null}>
      <Button
        buttonType="secondary"
        icon="eyeOff"
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          // Prevent slideout from opening
          e.stopPropagation();
          hideNotice();
        }}
      >
        {size === "default" ? "Hide notice" : null}
      </Button>
    </TooltipComponent>
  );
}
